import { Directive, HostBinding, Input, OnInit } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Directive({
  selector: 'mat-paginator[bsTablePaginator]',
})
export class TablePaginatorDirective implements OnInit {
  @Input() hasPagination = true;

  @HostBinding('class.bs-table-paginator')
  readonly tablePaginatorClass = true;

  @HostBinding('class.bs-table-paginator--hidden')
  get hidden(): boolean {
    return !this.hasPagination;
  }

  constructor(private readonly paginatorIntl: MatPaginatorIntl) {}

  ngOnInit(): void {
    this.paginatorIntl.itemsPerPageLabel = 'Itens por página';
    this.paginatorIntl.firstPageLabel = 'Primeira página';
    this.paginatorIntl.lastPageLabel = 'Última página';
    this.paginatorIntl.nextPageLabel = 'Próxima página';
    this.paginatorIntl.previousPageLabel = 'Página anterior';
    this.paginatorIntl.getRangeLabel = (page, pageSize, length) => {
      if (length === 0 || pageSize === 0) {
        return `0 de ${length}`;
      }

      const normalizedLength = Math.max(length, 0);
      const startIndex = page * pageSize;
      const endIndex =
        startIndex < normalizedLength
          ? Math.min(startIndex + pageSize, normalizedLength)
          : startIndex + pageSize;

      return `${startIndex + 1} - ${endIndex} de ${normalizedLength} Resultados`;
    };
    this.paginatorIntl.changes.next();
  }
}
